import {
  CLEAN_QUERIES_REDUCER,
  CLEAR_QUERIES,
  CREATE_NEW_MESSAGE,
  DELETE_QUERY,
  DELETE_QUERY_ERROR,
  GET_QUERIES,
  SET_QUERIES_LOADING,
  UPDATE_QUERIES,
  UPDATE_QUERY_TYPE,
} from './revealrTypes';

const initialState = {
  loading: false,
  queries: null,
};

const RevealrReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAN_QUERIES_REDUCER:
      return {
        ...state,
        loading: false,
        queries: null,
        usage: null,
      };
    case SET_QUERIES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case DELETE_QUERY:
      return {
        ...state,
        loading: false,
      };
    case DELETE_QUERY_ERROR:
      return {
        ...state,
        loading: false,
      };
    case CREATE_NEW_MESSAGE:
      return {
        ...state,
        queries: action.payload,
        loading: false,
      };
    case GET_QUERIES:
      return {
        ...state,
        queries: action.payload,
        loading: false,
      };
    case UPDATE_QUERIES:
      return {
        ...state,
        queries: action.payload,
      };
    case UPDATE_QUERY_TYPE:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_QUERIES:
      return {
        ...state,
        loading: false,
      };
    default:
      return { ...state };
  }
};

export default RevealrReducer;
